import {
  GET_VISITAS_START,
  GET_VISITAS_SUCCESS,
  GET_VISITAS_FAIL,
  GET_ACOES_START,
  GET_ACOES_SUCCESS,
  GET_ACOES_FAIL,
} from "../actions/user";

const initialState = {
  visitas: null,
  acoes: null,
  loadingVisitas: false,
  loadingAcoes: false,
  error: null,
};

const analyticsReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_VISITAS_START:
      return { ...state, loadingVisitas: true };
    case GET_VISITAS_SUCCESS:
      return {
        ...state,
        visitas: action.payload,
        loadingVisitas: false,
        error: null,
      };
    case GET_VISITAS_FAIL:
      return {
        ...state,
        visitas: null,
        loadingVisitas: false,
        error: action.payload,
      };
    case GET_ACOES_START:
      return { ...state, loadingAcoes: true };
    case GET_ACOES_SUCCESS:
      return {
        ...state,
        acoes: action.payload,
        loadingAcoes: false,
        error: null,
      };
    case GET_ACOES_FAIL:
      return {
        ...state,
        acoes: null,
        loadingAcoes: false,
        error: action.payload,
      };
    default:
      return state;
  }
};

export default analyticsReducer;
